var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/validator.ts
import { CLIENT_ENV_PREFIX } from "./client-env.js";
function isClientSide() {
  return typeof window !== "undefined";
}
__name(isClientSide, "isClientSide");
function isServerSide() {
  return !isClientSide();
}
__name(isServerSide, "isServerSide");
function isClientEnvKey(key) {
  return key.startsWith(CLIENT_ENV_PREFIX);
}
__name(isClientEnvKey, "isClientEnvKey");
function isServerEnvKey(key) {
  return !isClientEnvKey(key);
}
__name(isServerEnvKey, "isServerEnvKey");
function validateClientEnvKey(key) {
  if (!isClientEnvKey(key)) {
    throw new Error(`Client environment variable must start with ${CLIENT_ENV_PREFIX}\
: ${key}`);
  }
}
__name(validateClientEnvKey, "validateClientEnvKey");
function validateEnvAccess(key) {
  if (isClientSide() && !isClientEnvKey(key)) {
    throw new Error(
      `Cannot access server environment variable '${key}' on client side. Use ${CLIENT_ENV_PREFIX}\
 prefix for client variables.`
    );
  }
}
__name(validateEnvAccess, "validateEnvAccess");
export {
  isClientEnvKey,
  isClientSide,
  isServerEnvKey,
  isServerSide,
  validateClientEnvKey,
  validateEnvAccess
};
